import { PageCode } from '@/app/enums/pageName';

const getProductName = ({ url }: { url: string }) => {
  const products = [
    { type: 'capitulos-cenas', title: PageCode.CC },
    { type: 'planejamento', title: PageCode.PR },
    { type: 'roteiros-da-semana', title: PageCode.RS },
    { type: 'fotos', title: PageCode.FT },
    { type: 'e-prod', title: PageCode.EP },
    { type: 'relatorios', title: PageCode.RL },
    { type: 'cenas', title: PageCode.EP },
    { type: 'decupagens/continuidade', title: PageCode.DC },
    { type: 'decupagens/arte', title: PageCode.DA },
    { type: 'decupagens/basica', title: PageCode.DB },
    { type: 'decupagens/efeitos', title: PageCode.DEE },
    { type: 'indisponibilidade-de-elenco', title: PageCode.IE },
    { type: 'visoes', title: PageCode.VS },
    { type: 'blocos', title: PageCode.DB },
    { type: 'decupagens/figurino', title: PageCode.DF },
    { type: 'indicadores', title: PageCode.ID },
  ];

  return products.find((item) => url.includes(item.type))?.title;
};

export default getProductName;
